import React from 'react';
import { Joyride } from 'react-joyride';
import { useOnboarding } from '../../contexts/OnboardingContext';
import { TOUR_STEPS } from './StepDefinitions';

const JOYRIDE_LOCALE = {
  back: 'Retour',
  close: 'Fermer',
  last: 'Terminer',
  next: 'Suivant',
  skip: 'Passer',
};

export default function OnboardingTour() {
  const { tourRunning, completeOnboarding, updateStep, skipOnboarding } = useOnboarding();

  if (!tourRunning) return null;

  const handleCallback = (data) => {
    const { action, index, type } = data;
    if (type === 'step:after') {
      updateStep(index + 1);
    }
    if (action === 'close' || action === 'skip' || type === 'tour:end') {
      skipOnboarding();
    }
    if (action === 'reset') {
      updateStep(0);
    }
  };

  return (
    <Joyride
      steps={TOUR_STEPS}
      run={tourRunning}
      continuous
      showProgress
      showSkipButton
      disableOverlayClose
      hideCloseButton
      locale={JOYRIDE_LOCALE}
      styles={{
        options: {
          arrowColor: '#1e3a5f',
          backgroundColor: '#ffffff',
          overlayColor: 'rgba(0, 0, 0, 0.5)',
          primaryColor: '#2563eb',
          textColor: '#1f2937',
          zIndex: 9999,
        },
        tooltipContainer: {
          textAlign: 'left',
        },
        buttonNext: {
          backgroundColor: '#2563eb',
          color: '#ffffff',
          borderRadius: '8px',
          padding: '8px 16px',
          fontSize: '14px',
          fontWeight: 600,
        },
        buttonBack: {
          color: '#6b7280',
          marginRight: 8,
        },
        buttonSkip: {
          color: '#9ca3af',
        },
        tooltip: {
          borderRadius: '12px',
          boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
          padding: '20px',
        },
        tooltipContent: {
          padding: '10px 0',
          lineHeight: 1.6,
        },
        spotlight: {
          borderRadius: '8px',
        },
      }}
      callback={handleCallback}
    />
  );
}
